import React from "react";

import { EditOrderScreen } from "../components/blocks/EditOrderScreen.tsx";
import { NewOrderScreen } from "../components/blocks/NewOrderScreen.tsx";

import { useVehicleSelection } from "../providers/VehicleSelectionContext.tsx";

const Index: React.FC = () => {
  const { orderMode } = useVehicleSelection();

  return (
    <div className="max-w-[1240px] mx-auto">
      {orderMode === "new" && <NewOrderScreen />}
      {orderMode === "editing" && <EditOrderScreen />}
    </div>
  );
};

export default Index;
